/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableForAllocationInsuredOptionDto
 */
export interface AvailableForAllocationInsuredOptionDto {
    /**
     * 
     * @type {string}
     * @memberof AvailableForAllocationInsuredOptionDto
     */
    insuredId: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableForAllocationInsuredOptionDto
     */
    name: string;
}

/**
 * Check if a given object implements the AvailableForAllocationInsuredOptionDto interface.
 */
export function instanceOfAvailableForAllocationInsuredOptionDto(value: object): value is AvailableForAllocationInsuredOptionDto {
    if (!('insuredId' in value) || value['insuredId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AvailableForAllocationInsuredOptionDtoFromJSON(json: any): AvailableForAllocationInsuredOptionDto {
    return AvailableForAllocationInsuredOptionDtoFromJSONTyped(json, false);
}

export function AvailableForAllocationInsuredOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableForAllocationInsuredOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insuredId': json['insuredId'],
        'name': json['name'],
    };
}

export function AvailableForAllocationInsuredOptionDtoToJSON(json: any): AvailableForAllocationInsuredOptionDto {
    return AvailableForAllocationInsuredOptionDtoToJSONTyped(json, false);
}

export function AvailableForAllocationInsuredOptionDtoToJSONTyped(value?: AvailableForAllocationInsuredOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insuredId': value['insuredId'],
        'name': value['name'],
    };
}

